import React, {useRef, useMemo} from 'react'
import Header from '../component/Header'
import HomeBanner from '../component/HomeBanner'
import BrowseHome from '../component/BrowseHome'
import RecommendedYou from '../component/RecommendedYou'
import HomeCTA from '../component/HomeCTA'
import BrowseCountry from '../component/BrowseCountry'
import ExploreResultLocations from '../component/ExploreResultLocations'
import HomeRealEstateAgentForm from '../component/HomeRealEstateAgentForm'
import HomePropertyTypeSelector from '../component/HomePropertyTypeSelector'
import Footer from '../component/Footer'
import HomePageSkeleton from '../component/HomePageSkeleton'
import { usePageContent } from "../hooks/usePageContent";

function Home() {
  const { content, loading } = usePageContent("home");
  const recommendedRef = useRef(null);

  // Parse home_section data
  const homeSectionData = useMemo(() => {
    if (!content?.home_section) return null;
    try {
      return JSON.parse(content.home_section);
    } catch (error) {
      console.error("Error parsing home_section:", error);
      return null;
    }
  }, [content]);

  if (loading) {
    return <HomePageSkeleton />;
  }

  return (
    <>
      <div className='main home-page'>
        <Header />
        <HomeBanner 
          page_name={content?.page_name}
          bannerImage={content?.main_banner_image}
        />
        <BrowseHome 
          scrollToRecommended={() => recommendedRef.current?.scrollIntoView({ behavior: 'smooth' })}
          section={homeSectionData?.section_1}
        />
        <RecommendedYou 
          ref={recommendedRef}
          section={homeSectionData?.section_2}
        />
        <HomeCTA 
          section={homeSectionData?.section_3}
        />
        <HomePropertyTypeSelector 
          section={homeSectionData?.section_4}
        />
        <BrowseCountry />
        <HomeRealEstateAgentForm 
          section={homeSectionData?.section_6}
        />
        <ExploreResultLocations 
          section={homeSectionData?.section_5}
        />
        <Footer />
      </div>
    </>
  )
}
export default Home


